import * as wsAction from '../actions/wsActions/constants'
import * as hardwareAction from '../actions/hardwareActions/constants'

const initialState = {
    tokenPrice: null,
    cold_left: null,
    rates: null,
    hardwareFormData: null,
    directPaymentPopupData: null,
    isLoading: true,
    wsStatus: 'close',
    paymentPopupData: null,
    isProcessedPayment: false,
    isPromoCodeInfoFetch: false,
    promoError: '',
    promoCodeInfo: null,
    paymentId: '',
    hardwareDashboard: null,
    isLoadingHardwareDashboard: true,
    hardwareTransactions: null,
    isLoadingHardwareTransactions: true
};

const tokenReducer = (state = initialState, action) => {
    switch (action.type) {

        // case tokenAction.GET_PROMO_CODE_INFO_REQUEST:
        //     return {
        //         ...state,
        //         isPromoCodeInfoFetch: true
        //     };
        // case tokenAction.GET_PROMO_CODE_INFO_SUCCESS:
        //     return {
        //         ...state,
        //         isPromoCodeInfoFetch: false,
        //         promoCodeInfo: action.payload
        //     };
        // case tokenAction.GET_PROMO_CODE_INFO_FAILURE:
        //     return {
        //         ...state,
        //         isPromoCodeInfoFetch: false,
        //         promoError: action.payload,
        //         promoCodeInfo: null
        //     };
        case wsAction.WS_ON_CONNECT:
            return {
                ...state,
                wsStatus: 'connecting'
            };
        case wsAction.WS_ON_OPEN:
            return {
                ...state,
                wsStatus: 'open'
            };
        case wsAction.WS_ON_CLOSE:
            return {
                ...state,
                wsStatus: 'close'
            };
        case wsAction.WS_ON_MESSAGE:
            return {
                ...state,
                cold_left: action.payload.cold_left,
                tokenPrice: action.payload.cold_price,
                rates: action.payload
            };
        case hardwareAction.GET_HARDWARE_TRANSACTIONS_REQUEST:
            return {
                ...state,
                isLoadingHardwareTransactions: true,
            };
        case hardwareAction.GET_HARDWARE_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                isLoadingHardwareTransactions: false,
                hardwareTransactions: action.payload
            };
        case hardwareAction.GET_HARDWARE_TRANSACTIONS_FAILURE:
            return {
                ...state,
                isLoadingHardwareTransactions: false,
                hardwareTransactions: null
            };
        case hardwareAction.GET_HARDWARE_FORM_DATA_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case hardwareAction.GET_HARDWARE_FORM_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hardwareFormData: action.payload
            };
        case hardwareAction.GET_HARDWARE_FORM_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                hardwareFormData: null
            };
        case hardwareAction.GET_HARDWARE_DASHBOARD_REQUEST:
            return {
                ...state,
                isLoadingHardwareDashboard: true,
            };
        case hardwareAction.GET_HARDWARE_DASHBOARD_SUCCESS:
            return {
                ...state,
                isLoadingHardwareDashboard: false,
                hardwareDashboard: action.payload
            };
        case hardwareAction.GET_HARDWARE_DASHBOARD_FAILURE:
            return {
                ...state,
                isLoadingHardwareDashboard: false,
                hardwareDashboard: null
            };
        case hardwareAction.CREATE_PSP_PAYMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                isProcessedPayment: true,
            };
        case hardwareAction.CREATE_PSP_PAYMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                paymentPopupData: action.payload,
                isProcessedPayment: false
            };
        case hardwareAction.CREATE_PSP_PAYMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                paymentPopupData: null,
                isProcessedPayment: false
            };
        case hardwareAction.CREATE_DIRECT_PAYMENT_REQUEST:
            return {
                ...state,
                isLoading: true,
                isProcessedPayment: true,
            };
        case hardwareAction.CREATE_DIRECT_PAYMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                directPaymentPopupData: action.payload,
                isProcessedPayment: false,
                paymentId: action.payload.payment_id
            };
        case hardwareAction.CREATE_DIRECT_PAYMENT_FAILURE:
            return {
                ...state,
                isLoading: false,
                directPaymentPopupData: null,
                isProcessedPayment: false
            };
        case hardwareAction.CLEAR_PAYMENT_ID:
            return {
                ...state,
                paymentId: ''
            };
        default:
            return state
    }
}

export default tokenReducer